const parseEmails = (emails) => {
    if (!emails) return [];
    return emails.split(",").map((email) => email.trim()).filter(Boolean);
};

const escapeCsvValue = (value) => {
    const stringValue = String(value ?? "");
    if (/[",\n]/.test(stringValue)) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
};

export const exportVendorsToCsv = (vendors) => {
    const headers = [
        "Vendor ID",
        "Name",
        "Email(s)",
        "Account Number",
        "D1%",
        "D2%",
        "Bal%",
        "Cr%",
        "D1 Days",
        "D2 Days",
        "Bal Days",
        "Cr Days",
        "Ship Days",
    ];

    const rows = vendors.map((vendor) => [
        vendor.vendorId || "",
        vendor.name || "",
        parseEmails(vendor.emails).join(";"),
        vendor.accountNumber || "",
        vendor.depositFirst || 0,
        vendor.depositSecond || 0,
        vendor.balance || 0,
        vendor.credit || 0,
        vendor.depositFirstDays || 0,
        vendor.depositSecondDays || 0,
        vendor.balanceDays || 0,
        vendor.creditDays || 0,
        vendor.shippingDays || 0,
    ]);

    const csv = [headers, ...rows]
        .map((row) => row.map(escapeCsvValue).join(","))
        .join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `vendors-${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    URL.revokeObjectURL(url);
};
